export default "<footer class=\"footer\"><div class=\"container-fluid\">\n    © 2021 Template. All rights reserved.\n</div></footer>";